import { dateFormat } from '@app/constants'
import { getFormattedDate } from '@app/utils/date'

import type { TableData } from '@app/types/table'
import type { ResponseDto } from '@app/api/dtos'
import type { RegistryArchiveListsDataSource } from '../types'
import type { MonitoringListArchivesDto } from '@app/api/routes/monitoringLists/dtos'
import type { DecodedValueMap } from 'use-query-params'
import type { QueryParamConfigMap } from 'serialize-query-params'
import type { GetArchivesListsParams } from '@app/api/routes/monitoringLists/types'

export const adaptGetArchivesListsParams = (
  queryParams: DecodedValueMap<QueryParamConfigMap>
): GetArchivesListsParams => {
  return {
    monitoringTypeIds: queryParams.monitoringTypeIds,
    storeIds: queryParams.storeIds,
    clusterIds: queryParams.clusterIds,
    clustersGroupIds: queryParams.clustersGroupIds,
    salesOrganizationIds: queryParams.salesOrganizationIds,
    week: queryParams.week
  }
}

export const adaptRegistryArchiveListsTableData = (
  monitoringListArchivesResponse: ResponseDto<MonitoringListArchivesDto>
): TableData<RegistryArchiveListsDataSource> => {
  const { count, results: monitoringListArchives } = monitoringListArchivesResponse

  const dataSource: RegistryArchiveListsDataSource[] = monitoringListArchives.map(dto => ({
    key: dto.id,
    monitoringType: dto.monitoringType?.name ?? null,
    promotionName: dto.promo?.promotionNumber ?? null,
    promoDateFrom: getFormattedDate(dto.promo?.dateFrom, dateFormat.DD_MM_YYYY),
    promoDateTo: getFormattedDate(dto.promo?.dateTo, dateFormat.DD_MM_YYYY),
    store: dto.store?.name ?? null,
    cluster: dto.cluster?.name ?? null,
    clustersGroup: dto.clustersGroup?.name ?? null,
    salesOrganization: dto.salesOrganization?.name ?? null,
    week: dto?.week ?? null,
    approvalAt: getFormattedDate(dto.approvalAt, dateFormat.DD_MM_YYYY),
    comment: dto.comment ?? null
  }))

  return { count, dataSource }
}
